// MessageContext.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import Toast from '../components/ui/Toast.jsx';

let showMessageFn = null;
export function setShowMessage(fn) {
  showMessageFn = fn;
}
export function showMessage(msg, type = 'error') {
  if (showMessageFn) showMessageFn(msg, type);
}

const MessageContext = createContext(null);

export function useMessage() {
  return useContext(MessageContext);
}

export default function MessageProvider({ children }) {
  const [message, setMessage] = useState('');
  const [type, setType] = useState('error');

  const showMessageLocal = useCallback((msg, msgType = 'error') => {
    setMessage(msg);
    setType(msgType);
  }, []);

  const handleClose = useCallback(() => {
    setMessage('');
    setType('error');
  }, []);

  useEffect(() => {
    setShowMessage(showMessageLocal);
  }, [showMessageLocal]);

  return (
    <>
      <Toast message={message} type={type} onClose={handleClose} />
      <MessageContext.Provider value={{ showMessage: showMessageLocal, message, type }}>
        {children}
      </MessageContext.Provider>
    </>
  );
}


